var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('page-section', {
    staticClass: "page-section--first page-section--last page-section--sm"
  }, [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("오시는 길")])]), _c('div', {
    staticClass: "tit-wrap"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.7934776802185!2d126.83175787640566!3d37.55992922450596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9c65be69a98b%3A0x3d4d0fe99a385916!2z7ISc7Jq47Yq567OE7IucIOqwleyEnOq1rCDrp4jqs6HspJHslZk266GcIDY2!5e0!3m2!1sko!2skr!4v1760668046316!5m2!1sko!2skr",
      "width": "100%",
      "height": "540",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('v-sheet', {
    staticClass: "location-informations",
    attrs: {
      "color": "grey lighten-5",
      "rounded": "xl"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "60",
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "rounded-0",
    attrs: {
      "src": "/images/icon/icon-map.svg",
      "alt": "",
      "max-width": "22",
      "height": "auto"
    }
  })], 1)], 1), _c('v-col', [_c('div', {
    staticClass: "txt txt--dark line-height-15"
  }, [_c('div', {
    staticClass: "primary--text"
  }, [_vm._v("리본바이옴")]), _c('div', [_vm._v("서울특별시 강서구 마곡중앙6로 66, A동 907호")])])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "60",
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "rounded-0",
    attrs: {
      "src": "/images/icon/icon-map.svg",
      "alt": "",
      "max-width": "22",
      "height": "auto"
    }
  })], 1)], 1), _c('v-col', [_c('div', {
    staticClass: "txt txt--dark line-height-15"
  }, [_c('div', {
    staticClass: "primary--text"
  }, [_vm._v("웰빙엘에스")]), _c('div', [_vm._v("강원특별자치도 강릉시 과학단지로 24-19")])])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "60",
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "rounded-0",
    attrs: {
      "src": "/images/icon/icon-phone.svg",
      "alt": "",
      "max-width": "22",
      "height": "auto"
    }
  })], 1)], 1), _c('v-col', [_c('div', {
    staticClass: "txt txt--dark line-height-15"
  }, [_c('div', [_vm._v("02-6212-2825")])])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "60",
      "outlined": ""
    }
  }, [_c('v-img', {
    staticClass: "rounded-0",
    attrs: {
      "src": "/images/icon/icon-mail.svg",
      "alt": "",
      "max-width": "22",
      "height": "auto"
    }
  })], 1)], 1), _c('v-col', [_c('div', {
    staticClass: "txt txt--dark line-height-15"
  }, [_c('div', [_vm._v("rebornbiome@naver.com")])])])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }